import React, { useState } from 'react';
import Layout from '../../components/global/layout';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';


const Html = ({ handleSubmit, form, setForm, subbmitted }) => {


  return (
    <>
      <Layout>

        <div className="pprofile1 shadow-lg">
          <form onSubmit={e => handleSubmit(e)}>
            <div className='flex items-center mb-8'>

              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  Setting
                </h3>
                <p class="text-sm font-normal text-[#525252]">Here you can see all about your Setting</p>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">

              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Website Title<span className="star">*</span>
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  autoComplete="false"
                  value={form?.title}
                  onChange={(e) => {
                    setForm({ ...form, title: e.target.value });
                  }}
                  required
                />
              </div>

              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Email<span className="star">*</span>
                </label>
                <input
                  type="email"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  autoComplete="false"
                  value={form?.email}
                  onChange={(e) => {
                    setForm({ ...form, email: e.target.value });
                  }}
                  required
                />
              </div>
              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Mobile No.<span className='star'>*</span>
                </label>
                <div className="mobile_number">
                  <PhoneInput
                    value={form?.dialCode + '' + form?.mobileNo}
                    country={'us'}
                    enableSearch={true}
                    limitMaxLength
                    required
                    onChange={(e, a) => {
                      let phonenumber = e.replace(a.dialCode, '');
                      setForm({
                        ...form,
                        mobileNo: phonenumber,
                        dialCode: a?.dialCode,
                      });
                    }}
                    countryCodeEditable={true}
                  />
                  {subbmitted && !form.mobileNo ? (
                    <div className="invalid-feedback star d-block">
                      Mobile No. is Required
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>

              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Address
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  autoComplete="false"
                  value={form?.address}
                  onChange={(e) => {
                    setForm({ ...form, address: e.target.value });
                  }}
                  
                />
              </div>

              <div className="col-span-12 md:col-span-6 ">
                <label>
                  Website URL
                </label>
                <input
                  type="text"
                  className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                  autoComplete="false"
                  value={form?.website}
                  onChange={(e) => {
                    setForm({ ...form, website: e.target.value });
                  }}
                />
              </div>
            </div>
            <div className="flex justify-end">

              <button type="submit" className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
          </form>
        </div>

      </Layout>
    </>
  );
};

export default Html;
